















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";
import { pageData } from "../store/pageData";
import CommonParagraph from "@/components/CommonParagraph.vue";
import BottomBanner from "@/components/BottomBanner.vue";
import MilestonesCard from "@/components/MilestonesCard.vue";
import BusinessCard from "@/components/BusinessCard.vue";
import SingleImageCard from "@/components/SingleImageCard.vue";
import Accordion from "@/components/Accordion.vue";
import InvestorTab from "@/components/InvestorTab.vue";
import TextImgCard from "@/components/TextImgCard.vue";
import SliderBlock from "@/components/SliderBlock.vue";
import ManagementBlock from "@/components/ManagementBlock.vue";
import SlideBlock from "@/components/SlideBlock.vue";
import ImageLeftRight from "@/components/ImageLeftRight.vue";

import {
  TimelineMax,
  TweenLite,
  Power1,
  TweenMax,
  Expo,
  Power2,
  Power3,
  Power4,
} from "gsap";
@Component({
  name: "TeamBasicPage",
  components: {
    general_tab_block: Accordion,
    report_tab_block: InvestorTab,
    title_text_banner_image: BottomBanner,
    richtext_image: MilestonesCard,
    title_subtitle_richtext_cta: CommonParagraph,
    single_image: SingleImageCard,
    brand_logo_list: BusinessCard,
    title_text_image: TextImgCard,
    slide_block: SliderBlock,
    management_block: ManagementBlock,
    title_subtitle_slider_image: SlideBlock,
    about_image_tab_block: ImageLeftRight
  },
})
export default class TeamBasicPage extends Vue {
  @Prop() pageData!: pageDataType | null;
  public HOST: string = HOST;
  menu_list = [];
  menu_alllist = [];
  public heroimganim() {
    var heroimganim = new TimelineMax({});
    heroimganim
      .from(".banner-wrap", 1.3, {
        y: "100%",
        ease: Expo.easeInOut,
        clearProps: "all",
      })
      .from(".banner-wrap img", 0.7, {
        y: 0,
        scale: 1.2,
        ease: Power2.easeInOut,
        clearProps: "all",
      })
      .staggerFrom(
        ".banner-text",
        0.8,
        {
          autoAlpha: 0,
          height: 0,
          ease: Expo.easeInOut,
          clearProps: "all",
        },
        0.01,
        "-=.3"
      )
      .staggerFrom(
        ".banner-text h1",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".banner-text p",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      );
  }
  get_menu(){
     if ((this as any).pageData.parent_menu) {
    this.menu_list = (this as any).pageData.parent_menu.filter((item: any) => {
     return (this as any).pageData.title == item.title;
    });
     }
  }
get_allmenu(){
   if ((this as any).pageData.parent_menu) {
    this.menu_alllist = (this as any).pageData.parent_menu.filter((item: any) => {
     return (this as any).pageData.title !== item.title;
    });
   }
  }
  nextMove() {
    const conent = document.querySelector("#scroll-content");
    (conent as any).scrollLeft += 40;
  }
  prevMove() {
    const conent = document.querySelector("#scroll-content");
    (conent as any).scrollLeft -= 40;
  }

  public mounted() {
    this.heroimganim();
    this.get_menu();
    this.get_allmenu();
  }
}
